import React, { useEffect, useState } from "react";
import { MdInventory2 } from "react-icons/md";
import { isAuthenticated } from "../../auth";
import { elakayAutoText as text } from "../../pageInside/dataElakay";
import FilterUserProduct from "../../pageInside/filterUserProduct";
import ElakayFilterShell from "../../../components/SIdeDrawer/ElakayFilterShell";
import { dsApi } from "../services/wholesaleService";

// Filter Products (owner side). Reuses the Seller "Filter Products" component as-is -- number per page,
// Unpublished, Dropshipping only, shop categories, sort by created/updated/name/sold/quantity,
// ascending/descending, Clear All / Submit -- and injects the two Provider-only criteria that exist in
// the data: Wholesale products and Out of stock. Categories come from the owner's OWN products.
export const OWNER_SORT = { createdAt: "created", updatedAt: "updated", name: "name", "filterProduct.sold": "sold", "filterProduct.quantity": "stock" };
export const EMPTY_OWNER_FILTERS = { asc: "desc", unpublished: false, dropshipping: false, limit: 24, sortBy: "createdAt", search: "", wholesale: false, outOfStock: false, categoryIds: [] };

export default function ProviderProductsFilters({ draft, setDraft, onApply, click, gridButon, infoSource, embedded = false }) {
  const [categories, setCategories] = useState([]);
  useEffect(() => {
    let live = true;
    dsApi(isAuthenticated()?.token, "GET", "/provider/products/facets").then((r) => live && !r?.error && setCategories(r.categories || []));
    return () => { live = false; };
  }, []);

  // FilterUserProduct's Clear All resets with the Seller-shaped initial object (no Provider keys): any update
  // without our `wholesale` key is that reset, so it maps to the Provider defaults.
  const normalize = (next) => ("wholesale" in next ? next : EMPTY_OWNER_FILTERS);
  const extra = (
    <section className="elakay-user-filter-section">
      <div className="elakay-user-filter-heading"><span className="elakay-user-filter-number">+</span><h4>{text("h_pf_provider", "Provider criteria")}</h4></div>
      {[["wholesale", "h_ppc_wholesale", "Wholesale products"], ["outOfStock", "h_pp_out", "Out of stock"]].map(([k, tk, label]) => (
        <label className="elakay-user-switch" key={k} style={{ display: "flex", justifyContent: "space-between", gap: 8, marginBottom: 8 }}>
          <span>{text(tk, label)}</span>
          <input type="checkbox" name={k} checked={Boolean(draft[k])} onChange={() => setDraft({ ...draft, [k]: !draft[k] })} />
          <span className="elakay-user-switch-track"><span /></span>
        </label>
      ))}
    </section>
  );

  return (
    <ElakayFilterShell title={text("h_c8f73b98fa476d", "Filter Products")} icon={MdInventory2} embedded={embedded} click={click} gridButon={gridButon} bodyClassName="SideDrawer1-myshop-body">
      <FilterUserProduct
        infoSource={infoSource}
        getCategoriesUser={categories}
        getFilterUserProd={draft}
        setFilterUserProd={(next) => setDraft(normalize(next))}
        myFilters={{ filters: { "categoriesID.gategoriesLink": draft.categoryIds || [] } }}
        handleFilters={(values) => setDraft({ ...draft, categoryIds: values })}
        setMyFilters={() => {}}
        loadProductsByArrival={(token, deal, filters, current) => onApply(normalize(current))}
        infoFil={{}}
        setSowFilterOurTeam={() => click && click()}
        extraSections={extra}
      />
    </ElakayFilterShell>
  );
}
